// extracted by mini-css-extract-plugin
export default {"terms":"TermsAndConditions_terms__grWzu","section":"TermsAndConditions_section__T9Ait","confirmation":"TermsAndConditions_confirmation__l8Kq6"};